import { useLocation } from 'react-router-dom';
import { PORTFOLIOS_BENCHMARKS } from 'routes';
import { useAppSelector } from 'state/store';

type UseCurrentEntity = {
  selectedEntity: string;
  positionType: string;
};

export const useCurrentEntity = (): UseCurrentEntity => {
  const { pathname } = useLocation();
  const isBenchmark = pathname.startsWith(PORTFOLIOS_BENCHMARKS);
  const { selectedFund } = useAppSelector((state) => state.fundsState);
  const { selectedBenchmark } = useAppSelector((state) => state.benchmarkState);

  const selectedEntity = isBenchmark ? selectedBenchmark : selectedFund;
  const positionType = isBenchmark ? 'benchmarks' : 'funds';

  return { selectedEntity, positionType };
};
